const GUIDELINE_BASE_WIDTH = 375;
const GUIDELINE_BASE_HEIGHT = 812;

/**

 */
const getScaledSize = (size: number) => {
  if (typeof window === "undefined") return size; // Safety for SSR
  const scale = window.innerWidth / GUIDELINE_BASE_WIDTH;
  return Math.round(size * scale);
};

export const FontSizes = {
  font6: getScaledSize(6),
  font8: getScaledSize(8),
  font9: getScaledSize(9),
  font10: getScaledSize(10),
  font12: getScaledSize(12),
  font14: getScaledSize(14),
  font15: getScaledSize(15),
  font16: getScaledSize(16),
  font18: getScaledSize(18),
  font20: getScaledSize(20),
  font22: getScaledSize(22),
  font32: getScaledSize(32),
};

export const scaleVertical = (size: number) => {
  if (typeof window === "undefined") return size;
  return (window.innerHeight / GUIDELINE_BASE_HEIGHT) * size;
};

export const scaleHorizontal = (size: number) => {
  if (typeof window === "undefined") return size;
  return (window.innerWidth / GUIDELINE_BASE_WIDTH) * size;
};

export const scaleModerate = (size: number, factor = 0.5): number =>
  size + (scaleHorizontal(size) - size) * factor;
